import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import DialogServices from '../../services/dialog.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import { ModalAddReservedTimeComponent } from '../../components/modal-add-reserved-time/modal-add-reserved-time.component';
import { ModalBookingInfoComponent } from '../../components/modal-booking-info/modal-booking-info.component';
import { UiCalendarComponent } from '../../components/ui-calendar/ui-calendar.component';
import $ from 'jquery';
import moment from 'moment';
import { UiCalendarService } from '../../services/ui-calendar.service';
import GoogleRestServices from '../../services/google-rest.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import CalendarLocaleService from '../../services/calendar-locale.service';
import {
	ModalCalendarSelectionComponent
} from '../../components/modal-calendar-selection/modal-calendar-selection.component';
import {
	SynchronizeCalendarInfoPopoverComponent
} from '../../components/synchronize-calendar-info-popover/synchronize-calendar-info-popover.component';
import {ModalTagSelectionComponent} from "../../components/modal-tag-selection/modal-tag-selection.component";

@Component({
	standalone: true,
	selector: 'schedule',
	templateUrl: './schedule.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule, UiCalendarComponent, SynchronizeCalendarInfoPopoverComponent ]
})
export default class ScheduleComponent implements OnInit {
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private calendarService: UiCalendarService = inject(UiCalendarService);
	private googleRestServices: GoogleRestServices = inject(GoogleRestServices);
	private calendarLocaleService: CalendarLocaleService = inject(CalendarLocaleService);

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('schedule').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		const calendarLocale = this.calendarLocaleService.getFullCalendarLocale(this.vm.user.deviceLanguage);
		this.vm.businessServiceId = this.vm.user.service.id;
		this.vm.googleCalendarFeatureDisabled = !!this.vm.user.service.googleCalendarFeatureDisabled;
		this.vm.userEmail = this.vm.user.email;
		this.vm.origin = this.vm.user.origin;
		if(this.vm.origin === 'minudoc.ee')  {
			this.vm.originTitle = 'Minudoc';
		} else {
			this.vm.originTitle = 'Siffi';
		}
		!this.vm.user.businessUser ? this.angularRoutingHelperService.setPath('/') : null;
		this.vm.eventsFetched = false;
		this.vm.bookings = {};
		this.vm.bookings.events = [];
		this.vm.backgroundEvents = {};
		this.vm.backgroundEvents.rendering = 'background';
		this.vm.backgroundEvents.events = [];
		this.vm.googleCalendarIntegrated = false;
		
		this.vm.toConfigure = this.toConfigure;
		this.vm.openReserveTimeDialog = this.openReserveTimeDialog;
		this.vm.updateCalendarEvents = this.updateCalendarEvents;
		this.vm.showModalNotification = this.showModalNotification;
		this.vm.getLastSynchronizationDate = this.getLastSynchronizationDate;
		this.vm.lastSyncDate = this.angularFilterHelperService.translate('Calendar.Title.Never');
		this.vm.synchronize = this.synchronize;
		this.checkIntegrationEnabled();

		this.serviceRestServices.getSchedule({
			startDate: moment().format('YYYYMMDD'),
			endDate: moment().add(6, 'd').format('YYYYMMDD')
		}, (schedule) => {
			if (this.vm.user.businessUser) {
				this.serviceRestServices.getServiceByUserId({ userId: this.vm.user.id }, (service) => {
					console.log(service.status === 'INCOMPLETE');
					this.vm.service = service;
					this.vm.leadTimeInMinutes = this.vm.service?.nextAvailableLeadTimeInMinutes || 0;
				});
			}
			this.vm.pricing = schedule.pricing;
			
			// slot durations
			// [hours, minutes, seconds]
			var slotDurations: Array<any> = [];
			slotDurations.push('00');
			slotDurations.push(('0' + Math.floor(this.vm.pricing.timePerPrice / 2)).slice(-2));
			slotDurations.push(('0' + Math.round(this.vm.pricing.timePerPrice % 2 * 30)).slice(-2));
			this.vm.slotDuration = slotDurations.join(':');

			this.vm.bookings.events = [];
			this.angularHelperService.forEach(schedule.bookings, (booking) => {
				this.vm.bookings.events.push({
					communicationType: booking.communicationType,
					bookingOfficeAddress: booking.bookingOfficeAddress,
					start: booking.scheduledStart,
					end: booking.scheduledEnd,
					title: booking.user.firstname + ' ' + booking.user.lastname,
					backgroundColor: booking.status === 'PAYED' || booking.status === 'BOOKED'
						? '#d0ddff'
						: booking.status === 'CONFIRMED' || booking.status === 'COMPLETED' ? '#e8fffc' : '#ffdadc',
					borderColor: booking.status === 'PAYED' || booking.status === 'BOOKED'
						? '#507bfa'
						: booking.status === 'CONFIRMED' || booking.status === 'COMPLETED' ? '#30b8a1' : '#ff3f3f',
					comment: booking.comment,
					user: booking.user,
					status: booking.status,
					bookingId: booking.id,
					textColor: '#808080',
					callType: booking.callType,
					price: booking.price
				});
			});
			
			this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
				this.vm.backgroundEvents.events.push({
					start: slot.startTime === slot.endTime
						? moment(slot.startTime).utc().startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
						: moment(slot.startTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
					end: slot.startTime === slot.endTime
						? moment(slot.startTime).utc().startOf('day').add(1440, 'minutes').format('YYYY-MM-DDTHH:mm:ss[Z]')
						: slot.endTime,
					id: slot.id,
					recurring: slot.recurringType,
					textColor: '#fff'
				});
			});
			this.vm.eventsFetched = true;
			
			this.vm.uiConfig = {
				calendar: {
					header: {
						left: 'title',
						center: '',
						right: 'today agendaWeek month prev,next'
					},
					allDaySlot: false,
					nowIndicator: false,
					eventLimit: 4,
					eventLimitText: calendarLocale.eventLimitText,
					eventLimitClick: 'agendaWeek',
					height: 'auto',
					contentHeight: 'auto',
					slotLabelFormat: 'H:mm',
					minTime: '00:00:00',
					maxTime: '24:00:00',
					timezone: 'local',
					slotDuration: this.vm.slotDuration,
					firstDay: 1,
					defaultView: (this.angularHelperService.getWindow().innerWidth <= 700) ? 'agendaDay' : 'agendaWeek',
					slotLabelInterval: '01:00:00',
					timeFormat: 'H:mm',
					views: {
						agenda: {
							columnFormat: 'DD.MM dddd'
						},
						month: {
							columnFormat: 'dddd',
							contentHeight: 700
						}
					},
					dayClick: (date, allDay, jsEvent, view) => {
						if (this.angularHelperService.getWindow().innerWidth > 700) {
							var calendarElement: any = $('#cal');
							calendarElement.fullCalendar('changeView', 'agendaWeek');
							calendarElement.fullCalendar('gotoDate', date);
						}
					},
					viewRender: (view, element) => {
						console.log('calendar.viewRender triggered');
						view.type !== 'month' ? $('.fc-left').css('display', 'none') : $('.fc-left').css('display', 'block');
						var calendarElement: any = $('#cal');
						calendarElement.fullCalendar('removeEvents');
						this.vm.bookings = {};
						this.vm.bookings.events = [];
						this.vm.exclusions = {};
						this.vm.exclusions.events = [];
						this.vm.backgroundEvents = {};
						this.vm.backgroundEvents.rendering = view.type === 'month' ? undefined : 'background';
						this.vm.backgroundEvents.events = [];
						this.serviceRestServices.getSchedule({
							startDate: moment(view.start).format('YYYYMMDD'),
							endDate: moment(view.end).format('YYYYMMDD')
						}, (schedule) => {
							
							if (schedule.excludeDates && schedule.excludeDates.length > 0 && view.type !== 'month') {
								this.angularHelperService.forEach(schedule.excludeDates, (excluded) => {
									this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
										moment(slot.startTime).isSame(excluded.excludeDate, 'day') ? slot.isExcluded = true : null;
									});
									this.angularHelperService.forEach(this.angularHelperService.element('.fc-day-header'), (value, key) => {
										var date: any = moment(value.attributes['data-date'].value).format('YYYYMMDD');
										if (moment(date).isSame(excluded.excludeDate, 'day')) {
											this.angularHelperService.element(value).addClass('fc-disabled-day');
										}
									});
									this.angularHelperService.forEach(this.angularHelperService.element('.fc-day'), (value, key) => {
										var date: any = moment(value.attributes['data-date'].value).format('YYYYMMDD');
										if (moment(date).isSame(excluded.excludeDate, 'day')) {
											this.angularHelperService.element(value).addClass('fc-disabled-day');
										}
									});
								});
							}

							this.vm.exclusions.events = [];
							if (schedule.excludedDateTimes && schedule.excludedDateTimes.length > 0 && view.type !== 'month') {
								this.angularHelperService.forEach(schedule.excludedDateTimes, (event) => {
									this.vm.exclusions.events.push({
										start: event.startDateTime === event.endDateTime
											? moment(event.startDateTime).utc().startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
											: moment(event.startDateTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
										end: event.startDateTime === event.endDateTime
											? moment(event.startDateTime).utc().startOf('day').add(1440, 'minutes').format('YYYY-MM-DDTHH:mm:ss[Z]')
											: moment(event.endDateTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
										id: event.id,
										recurring: event.recurringType,
										textColor: '#f00',
										title: 'Busy',
										backgroundColor: '#ffdadc',
										borderColor: '#ff3f3f'
									});
								});
							}

							this.vm.bookings.events = [];
							this.angularHelperService.forEach(schedule.bookings, (booking) => {
								this.vm.bookings.events.push({
									communicationType: booking.communicationType,
									bookingOfficeAddress: booking.bookingOfficeAddress,
									start: booking.scheduledStart,
									end: booking.scheduledEnd,
									title: booking.status === 'RESERVED' ? '' : booking.user.firstname + ' ' + booking.user.lastname,
									backgroundColor: booking.status === 'PAYED' || booking.status === 'BOOKED'
										? '#d0ddff'
										: booking.status === 'CONFIRMED' || booking.status === 'COMPLETED' ? '#e8fffc' : '#ffdadc',
									borderColor: booking.status === 'PAYED' || booking.status === 'BOOKED'
										? '#507bfa'
										: booking.status === 'CONFIRMED' || booking.status === 'COMPLETED' ? '#30b8a1' : '#ff3f3f',
									comment: booking.comment,
									user: booking.user,
									status: booking.status,
									reservationLink: booking.reservationLink,
									bookingId: booking.id,
									textColor: '#808080',
									callType: booking.callType,
									price: booking.price
								});
							});

							if (schedule.timeSlots && schedule.timeSlots.length > 0 && view.type !== 'month') {
								this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
									this.vm.backgroundEvents.events.push({
										start: slot.startTime === slot.endTime
											? moment(slot.startTime).utc().startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
											: moment(slot.startTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
										end: slot.startTime === slot.endTime
											? moment(slot.startTime).utc().startOf('day').add(1440, 'minutes').format('YYYY-MM-DDTHH:mm:ss[Z]')
											: moment(slot.endTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
										id: slot.id,
										recurring: slot.recurringType,
										textColor: '#fff'
									});

								});
							}

							this.vm.eventsFetched = true;
							const saveDelayOverlay = this.buildDelayOverlay(moment(view.end));

							if (saveDelayOverlay) {
								this.vm.backgroundEvents.events.push(saveDelayOverlay);
							}

							var calendarElement: any = $('#cal');
							calendarElement.fullCalendar('removeEvents');
							calendarElement.fullCalendar('addEventSource', this.vm.backgroundEvents);
							calendarElement.fullCalendar('addEventSource', this.vm.bookings);
							calendarElement.fullCalendar('addEventSource', this.vm.exclusions);
							calendarElement.fullCalendar('refetchEvents');
							
						}, (error) => { });
						
					},
					windowResize: (view) => {
						var calendarElement: any = $('#cal');
						this.vm.width = this.angularHelperService.getWindow().innerWidth;
						this.vm.width <= 700
							? calendarElement.fullCalendar('changeView', 'agendaDay')
							: view.type !== 'agendaDay'
								? calendarElement.fullCalendar('changeView', view.type)
								: calendarElement.fullCalendar('changeView', 'agendaWeek');
					},
					eventRender: (event, element) => {
						var calendarElement: any = $('#cal');
						if (event.source.rendering !== 'background' && calendarElement.fullCalendar('getView').type !== 'month') {
							
							if (event.status === 'RESERVED') {
								var s1 = '<span style="float:right;font-size:10px;cursor:pointer;padding:2px;margin-right:5px!important;"'
									+ ' class="o-icon o-icon--copy"></span>'
								element.prepend(s1);
								element.children('.o-icon--copy').attr('data-event-id', event.id);
							}
							element.find('.o-icon--copy').on('click', (elem) => {
								var copyElement: any = document.createElement("span");
								copyElement.appendChild(document.createTextNode(event.reservationLink));
								copyElement.id = 'tempCopyToClipboard';
								this.angularHelperService.element(document.body.append(copyElement));
								
								// select the text
								var range: any = document.createRange();
								range.selectNode(copyElement);
								var _window: any = window;
								_window.getSelection().removeAllRanges();
								_window.getSelection().addRange(range);
								
								// copy & cleanup
								document.execCommand('copy');
								_window.getSelection().removeAllRanges();
								copyElement.remove();
							});

							if (event.title !== 'Busy') {
								var html = '<span style="float:right;font-size:10px;cursor:pointer;padding:2px;" class="o-icon o-icon--edit"></span>';
								element.prepend(html);
								element.children('.o-icon--edit').attr('data-event-id', event.id);
								element.find('.o-icon--edit').on('click', (elem) => {
									console.log(event);
									var booking: any = {
										communicationType: event.communicationType,
										bookingOfficeAddress: event.bookingOfficeAddress,
										scheduledStart: event.start,
										scheduledEnd: event.end,
										name: event.title,
										comment: event.comment,
										price: event.price,
										status: event.status,
										id: event.bookingId,
										user: event.user,
										callType: event.callType,
										reservationLink: event.reservationLink
									};
									this.dialogServices.show({
										controller: ModalBookingInfoComponent,
										booking: booking
									});
								});
							}
						}
					}
					
				}
			};
			Object.assign(this.vm.uiConfig.calendar, calendarLocale);
			
			this.vm.scheduleLoaded = true;
		}, console.error);
	}
	
	toConfigure() {
		this.angularRoutingHelperService.setPath('/schedule/configure');
	}

	getLastSynchronizationDate(){
		const lastSyncDate = this.vm.lastSyncDate;
		const notSynchronized = this.angularFilterHelperService.translate('Calendar.Title.Never');
		const userLanguage = this.vm.user.deviceLanguage || 'en-GB';
		const locale = userLanguage.replace('_', '-');

		if (!lastSyncDate) {
			return this.angularFilterHelperService.translate('Calendar.Title.Last_Synchronization').replace('%s', notSynchronized);
		}

		const formattedLastSyncDate = new Date(lastSyncDate).toLocaleString(locale, {
			day: '2-digit',
			month: 'short',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false
		});

		return this.angularFilterHelperService.translate('Calendar.Title.Last_Synchronization').replace('%s', formattedLastSyncDate);
	}

	showModalNotification() {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Calendar.Title.Notification_Title'),
			content: this.angularFilterHelperService.translate('Calendar.Title.Notification').replaceAll('%s', this.vm.originTitle),
		});
		dialog.afterClosed().subscribe((confirmed) => {
			if (confirmed) {
				console.log('User confirmed integration');
				this.vm.googleCalendarIntegrated = true;
				this.integrateGoogleCalendar();
			}
		});
	}

	private checkIntegrationEnabled() {
		this.googleRestServices.checkIntegrationEnabled(
			(response) => {
				this.vm.googleCalendarIntegrated = response.hasToken;
				this.vm.lastSyncDate = response.lastSyncDate;
			},
			(error) => {
				console.error('Error in show Integrate Button:', error);
			}
		);
	}

	private integrateGoogleCalendar() {
		this.googleRestServices.authorize(
			(response) => {
				const url = response?.body?.authorizationUrl;
				if (url) {
					window.location.href = url;
				}
			},
			(error) => {
				const url = error?.body?.authorizationUrl;
				if (url) {
					window.location.href = url;
				} else {
					console.error('Authorization failed:', error);
				}
			}
		);
	}

	private synchronize() {
		this.openCalendarSelectionDialog();
	}

	extraEventSignature(event) {
		return event.status;
	}
	buildDelayOverlay(viewEnd: moment.Moment) {
		const now = moment();
		const delayEnd = moment().add(this.vm.leadTimeInMinutes, 'minutes');

		if (this.vm.leadTimeInMinutes <= 0 || now.isAfter(viewEnd)) {
			return null;
		}

		return {
			start: now,
			end: moment.min(delayEnd, viewEnd),
			rendering: 'background',
			backgroundColor: '#ffe0b2',
			overlap: false,
			isDelay: true
		};
	}


	openReserveTimeDialog() {
		var dialog = this.dialogServices.show({
			controller: ModalAddReservedTimeComponent,
			mode: 'CREATE'
		});
		dialog.afterClosed().subscribe(
			() => {
				this.angularHelperService.getWindow().location.reload();
			},
			() => {
				this.angularHelperService.getWindow().location.reload();
			}
		);
	}
	
	updateCalendarEvents() {
		var calendarElement: any = $('#cal');
		console.log('updateCalendarEvents triggered');
		this.vm.bookings.events = [];
		this.calendarService.getById('scheduleCalendar').fullCalendar('removeEventSource', this.vm.bookings);
		this.serviceRestServices.getSchedule({
			startDate: moment(calendarElement.fullCalendar('getView').start).format('YYYYMMDD'),
			endDate: moment(calendarElement.fullCalendar('getView').end).format('YYYYMMDD')
		}, (schedule) => {
			this.vm.bookings = {};
			this.vm.bookings.events = [];
			this.angularHelperService.forEach(schedule.bookings, (booking) => {
				
				this.vm.bookings.events.push({
					communicationType: booking.communicationType,
					bookingOfficeAddress: booking.bookingOfficeAddress,
					start: booking.scheduledStart,
					end: booking.scheduledEnd,
					title: booking.user.firstname + ' ' + booking.user.lastname,
					backgroundColor: booking.status === 'PAYED' || booking.status === 'BOOKED'
						? '#d0ddff'
						: booking.status === 'CONFIRMED' || booking.status === 'COMPLETED' ? '#e8fffc' : '#ffdadc',
					borderColor: booking.status === 'PAYED' || booking.status === 'BOOKED'
						? '#507bfa'
						: booking.status === 'CONFIRMED' || booking.status === 'COMPLETED' ? '#30b8a1' : '#ff3f3f',
					comment: booking.comment,
					user: booking.user,
					status: booking.status,
					bookingId: booking.id,
					textColor: '#808080',
					callType: booking.callType
				});
			});
			this.angularHelperService.createTimer(() => {
				this.calendarService.getById('scheduleCalendar').fullCalendar('removeEvents');
				this.calendarService.getById('scheduleCalendar').fullCalendar('removeEventSource', this.vm.bookings);
				this.calendarService.getById('scheduleCalendar').fullCalendar('addEventSource', this.vm.bookings);
				this.calendarService.getById('scheduleCalendar').fullCalendar('refetchEvents');
			});
		});
	}

	openCalendarSelectionDialog() {
		var dialog = this.dialogServices.show({
			controller: ModalCalendarSelectionComponent,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false,
		});
		dialog.afterClosed().subscribe(
			(data) => {
				if (data === 'refresh') {
					window.location.reload();
				}
			},
			() => {}
		);
	}
	
}
